export const validEmail = new RegExp(
    '^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$'
 );
 export const validPassword = new RegExp('^(?=.*[A-Z])(?=.*?[a-z])(?=.*[!@#$%^&*()_+{}|:<>?,./])(?=.*?[0-9]).{6,}$');
 export const validUsername = new RegExp('^[A-Za-z][A-Za-z0-9_-]{5,29}$')